import { Box, styled } from "@mui/material";
import { getPrimaryColor } from "utils/theme";

export const Container = styled(Box)(() => ({
  display: "flex",
  minWidth: "100vw",
  minHeight: "100vh",
}));

export const Body = styled(Box)<{ collapsed?: boolean; isMobile: boolean }>(
  ({ collapsed, isMobile }) => {
    const sidebarWidth = collapsed ? 60 : 280;
    return {
      flex: 1,
      backgroundColor: getPrimaryColor()[700],
      paddingTop: isMobile ? "0px" : "12px",
      marginLeft: isMobile ? "0px" : `${sidebarWidth}px`,
      maxWidth: isMobile ? "100vw" : `calc(100vw - ${sidebarWidth}px)`,
      transition: isMobile ? "" : "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    };
  }
);

export const Content = styled(Box)<{ isMobile: boolean }>(
  ({ theme, isMobile }) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: !isMobile ? "40px 0px 0px 0px" : "0px",
    padding: isMobile ? "12px" : "32px",
    height: "100%",
  })
);
